module.exports = __webpack_public_path__ + "static/jonas-meduna.c04ecc86.jpeg";


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/HomePage/Reviews/jonas-meduna.jpeg
// module id = 705
// module chunks = 0